module.exports = __webpack_public_path__ + "static/media/StevenGarciaResume.5eaa6f5d.pdf";